import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
  ViewChild,
  TemplateRef,
} from "@angular/core";
import { NbDialogService } from "@nebular/theme";
import { HttpClient } from "@angular/common/http";
import { CookieService } from "ngx-cookie-service";
import * as _ from "lodash";
import { DatePipe } from '@angular/common';

@Component({
  selector: "app-edit-EOS-product",
  templateUrl: "./edit-EOS-product.component.html",
  styleUrls: ["./edit-EOS-product.component.scss"],
})
export class EditEOSProductComponent implements OnInit {
  @Output() emitList = new EventEmitter();
  @Output() emitClose = new EventEmitter();
  @Input() orgData: ModifyPRDProductReq; //已選資料_來源
  @Input() info: {
    IsLoding:boolean,
    moType: number; //目前編輯狀態 1.新增 2.編輯 3.複製 4.查看
    orgType: number; //來源類型 1.設定檔&設定檔附加品項中 2.菜單檔 3.使用中菜單檔&使用中菜單檔附加品項中 
    pdShowType: number; //1.商品 2.附加品項中商品
    pfType:number;//平台類型 1.POS 2.享online 3.uber 4.panda
    ORG_Store_ID:null
    groupList: selectData[];    
    isChange_Group : boolean;
    EOSProductGroupNo:null
    PRDMenuProductGroupNo:null
    storeList: selectData[];
    

    //-------old------------
    PRDProductGroupNo: null;
    EOSProductNo: null;
  };
  //標題
  moTitle: string;
  title2: string;
  //主要資料
  mealData: ModifyPRDProductReq;

  //操作者資料
  USR_AccountInfo_ID: string;
  USR_EmployeeInfo_ID: string;
  ORG_Company_ID: number;
  ORG_Store_ID: number;
  authChangeSub:any;

  //圖片
  testFiles;

  //---------------選項列表-------->--------------//
  //稅率列表
  TaxRateList = [];
  TaxTypeList = [
    { value: 1, content: "免稅" },
    { value: 2, content: "應稅" },
    { value: 3, content: "零稅" },
  ];

  //-------<--------選項列表----------------------//

  @ViewChild("Modal") Modal: TemplateRef<any>;
  modalRef = null; //談窗鉤子
  @ViewChild("DayModal") DayModal: TemplateRef<any>;
  dayModalRef = null; //談窗鉤子

  constructor(
    private http: HttpClient,
    private dialogService: NbDialogService,
    private cookieService: CookieService,
    private datePipe: DatePipe,
  ) {
    this.USR_AccountInfo_ID = this.cookieService.get('USR_AccountInfo_ID') ? 
      "USR_AccountInfo_ID_"+this.cookieService.get('USR_AccountInfo_ID') :
        this.cookieService.get('USR_POSEmployeeInfo_ID') ?  
          "USR_POSEmployeeInfo_ID"+this.cookieService.get('USR_POSEmployeeInfo_ID') : null
    this.USR_EmployeeInfo_ID = this.cookieService.get('USR_EmployeeInfo_ID')
    this.ORG_Company_ID = parseInt(this.cookieService.get('ORG_Company_ID'))
    let cookie_sid = this.cookieService.get('ORG_Store_ID')
    this.ORG_Store_ID= (cookie_sid && cookie_sid!='') ? parseInt(cookie_sid) : null
  }
  
  ngOnInit(): void {
    for (let i = 1; i < 100; i++) {
      this.TaxRateList.push({ value: i, content: i + "%" });
    }
  }

  ngAfterViewInit() {
    this.onOpen(this.info, this.orgData)
  }

  onOpen(info, data) {
    if (info) this.info = info;

    this.mealData = new ModifyPRDProductReq();
    this.getStoreList()
    this.toSalesOutletDetail(data);
    this.toStoreSaleCashDetail(data);
    
    if (this.info.moType == 1) {
      this.moTitle = "新增";

      this.mealData.EOSProductGroupNo = this.info.EOSProductGroupNo
      this.mealData.PRDMenuProductGroupNo= this.info.PRDMenuProductGroupNo
    }
    else if (this.info.moType == 2) {
      this.moTitle = "編輯";
      if (data) {
        this.toProductDetail(data);
      } 
    }
    else if (this.info.moType == 3) {
      this.moTitle = "複製";
      if (data) {
        this.toProductDetail(data);
        this.mealData.EOSProductNo = null;
      }

      if(this.info.orgType == 1){
        this.getStoreList()
      }

    }
    else if (this.info.moType == 4) {
      this.moTitle = "查看";
      if (data) {
        this.toProductDetail(data);
      } else {
        this.getProductDetail(null);
      }
    }

    if (this.info.orgType == 1) {
      this.title2 = "預設資料";
    }
    else if (this.info.orgType == 2) {
      this.title2 = "可調整資料";
      if(!this.mealData.SupplyQTY)
      this.mealData.SupplyQTY = 10000;
    }
    else if (this.info.orgType == 3) {
      this.title2 = "販售資料";
    }

    if(!info.pdShowType){
      info.pdShowType=1
    }

    this.modalRef = this.dialogService.open(this.Modal, {});
    this.modalRef.onClose.subscribe(result => {
      this.emitClose.emit(true);
    });
  }

  onSave() {
    if (!this.mealData.Cash && this.mealData.Cash != 0) {
      alert("商品原價必須填!");
      return null;
    }
    if (!this.mealData.SaleCash && this.mealData.SaleCash != 0) {
      alert("商品售價必須填!");
      return null;
    }

    //轉換營業時段
    if (this.mealData.supplyPeriod && this.mealData.supplyPeriod.length ) {
      if (this.mealData.supplyPeriod.length >= 1) {
        this.mealData.FirstSupplyStartTime = 
          this.datePipe.transform(this.mealData.supplyPeriod[0].startTime, 'yyyy/MM/dd HH:mm:ss')
        
        this.mealData.FirstSupplyEndTime = 
          this.datePipe.transform(this.mealData.supplyPeriod[0].endTime, 'yyyy/MM/dd HH:mm:ss')

          if(this.mealData.supplyPeriod[0].startTime > this.mealData.supplyPeriod[0].endTime){
            alert("開始日期不可大於結束日期!")
            return 
          }
      }
    


      if (this.mealData.supplyPeriod.length >= 2) {
        this.mealData.SecondSupplyStartTime = 
          this.datePipe.transform(this.mealData.supplyPeriod[1].startTime, 'yyyy/MM/dd HH:mm:ss')
        this.mealData.SecondSupplyEndTime = 
          this.datePipe.transform(this.mealData.supplyPeriod[1].endTime, 'yyyy/MM/dd HH:mm:ss')

          if(this.mealData.supplyPeriod[1].startTime > this.mealData.supplyPeriod[1].endTime){
            alert("開始日期不可大於結束日期!")
            return
          }
      }
    }
    else{
      this.mealData.FirstSupplyStartTime = ""
      this.mealData.FirstSupplyEndTime = ""
      this.mealData.SecondSupplyStartTime = ""
      this.mealData.SecondSupplyEndTime = ""
    }

    
    
    //圖片處理
    if (this.mealData.files && this.mealData.files.length > 0) {
      this.mealData.Image = this.mealData.files[0].path;
    }

    //加購品項
    let attachItemGroups: string = "";
    if (this.mealData.AttachItemGroupJsonDatas) {
      let data = _.orderBy(this.mealData.AttachItemGroupJsonDatas,x=>['Sorting'], ['asc'])
      data.forEach((item) => {
        if (attachItemGroups == "") {
          attachItemGroups = item.PRDMenuAttachItemGroupNo;
        } else {
          attachItemGroups = attachItemGroups + "," + item.PRDMenuAttachItemGroupNo;
        }

        item.Sorting = item.Sorting*1
      });
    }
    this.mealData.AttachItemGroupJsonData = attachItemGroups;

    let ProductStoreCashData = this.mealData.ProductStoreCashMapJsonData ?
    this.mealData.ProductStoreCashMapJsonData
        .filter(item => item.SaleCash !== null) 
        .map(({ storeName, ...rest }) => ({ ...rest })) :
    [];

    if (this.mealData.ProductStoreMapJsonDatas === undefined){
      this.mealData.ProductStoreMapJsonDatas = []
    }
    
    //格式處理
    let Main = {
      ProductName: this.mealData.ProductName,
      ProductContant: this.mealData.ProductContant,
      Image: this.mealData.Image,
      TaxRate: this.mealData.TaxRate,
      TaxType: this.mealData.TaxType,
      Cash: this.mealData.Cash,
    }
    let Detail = {
      SaleCash: this.mealData.SaleCash,
      Sorting: this.mealData.Sorting,
      IsOpenTakeout: this.mealData.IsOpenTakeout,
      IsOpenDelivery: this.mealData.IsOpenDelivery,
      IsOpenDining: this.mealData.IsOpenDining,
      IsOpenSelfPickup: this.mealData.IsOpenSelfPickup,
      IsOpenReserveDining: this.mealData.IsOpenReserveDining,
      SupplyQTY: this.mealData.SupplyQTY,
      UplimitQTY: this.mealData.UplimitQTY,
      SupplyDay: this.mealData.SupplyDay,
      FirstSupplyStartTime: this.mealData.FirstSupplyStartTime,
      FirstSupplyEndTime: this.mealData.FirstSupplyEndTime,
      SecondSupplyStartTime: this.mealData.SecondSupplyStartTime,
      SecondSupplyEndTime: this.mealData.SecondSupplyEndTime,
      AttachItemGroupJsonDatas: this.mealData.AttachItemGroupJsonDatas,
      ProductStoreMapJsonDatas: this.mealData.ProductStoreMapJsonDatas,
      ProductStoreCashMapJsonDatas: ProductStoreCashData,
    }
    this.mealData.Main = Main
    this.mealData.Detail = Detail
    this.mealData.ORG_Company_ID = this.ORG_Company_ID;
    this.mealData.USR_EmployeeInfo_ID = parseInt(this.USR_EmployeeInfo_ID);
    this.mealData.USR_AccountInfo_ID = this.USR_AccountInfo_ID; //建立者;

    console.log('送出',this.mealData)

    this.emitList.emit(this.mealData);
    // this.modalRef.close();
  }


  //商品彈窗  新增供應時段
  addSupplyData() {
    if (this.mealData.supplyPeriod == null) {
      this.mealData.supplyPeriod = [];
    }
    if (this.mealData.supplyPeriod.length >= 2) {
      return;
    }
    this.mealData.supplyPeriod.push(new supplyPeriod());
  }

  //商品彈窗  刪除供應時段
  delSupplyData(idx) {
    this.mealData.supplyPeriod.splice(idx, 1);
  }

  //商品彈窗 供應日期 設定
  addSupplyTime() {
    this.dayModalRef = this.dialogService.open(this.DayModal, {});
  }
  //商品彈窗 供應日期 顯示
  showSupplyTime() {
    var str = [];
    var value = [];
    this.mealData.SupplyDay = "";
    if (this.mealData.supplyTimeMonday) {
      str.push("星期一");
      value.push("1");
    }
    if (this.mealData.supplyTimeTuesday) {
      str.push("星期二");
      value.push("2");
    }
    if (this.mealData.supplyTimeWednesday) {
      str.push("星期三");
      value.push("3");
    }
    if (this.mealData.supplyTimeThursday) {
      str.push("星期四");
      value.push("4");
    }
    if (this.mealData.supplyTimeFriday) {
      str.push("星期五");
      value.push("5");
    }
    if (this.mealData.supplyTimeSaturday) {
      str.push("星期六");
      value.push("6");
    }
    if (this.mealData.supplyTimeSunday) {
      str.push("星期日");
      value.push("7");
    }
    if (str.length > 0) {
      //去掉第一個逗號
      this.mealData.supplyDayStr = str.join(",");
      this.mealData.SupplyDay = value.join(",");
    }

    if (this.dayModalRef)
      this.dayModalRef.close()

    return str;
  }

  //商品彈窗 上傳圖片用
  fileToBase64 = (file: File): Promise<string> => {
    return new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result.toString());
      reader.onerror = (error) => reject(error);
    });
  };


  //商品彈窗 圖片上傳
  onSelect(event,dataBox) {
    console.log(event);
    dataBox.files = [];
    if (event.addedFiles == null || event.addedFiles.length == 0) {
      return;
    }

    
    dataBox.files.push(event.addedFiles[0]);
    
    const formData = new FormData();

    for (var i = 0; i < dataBox.files.length; i++) {
      formData.append("file[]", dataBox.files[i]);
    }

    let imgdata  = {}
    if (dataBox.files && dataBox.files[0]) {
      for (let i = 0; i < dataBox.files.length; i++) {
        this.fileToBase64(dataBox.files[i]).then((result) => {
          const base64String = result;

          imgdata = {
            base64: base64String,
            functionType: "1",
            ORG_Company_ID:this.ORG_Company_ID,
            ORG_Store_ID:this.info.ORG_Store_ID
          };
          
          this.info.IsLoding = true;
          this.http
          .post<any>("api/ImageUpload/ImageUpload", imgdata)
          .subscribe({
            next: (data) => {
              console.log(data);
              dataBox.files[0].path = data.path;
              console.log(dataBox.files[0].path);
              this.info.IsLoding = false;
            },
            error: (error) => {
              console.error("There was an error!", error);
            },
          });
        });
      }
    }


  
  }

  //商品彈窗 圖片清除
  onRemove(event,dataBox) {
    console.log(event);
    // dataBox.files.splice(dataBox.files.indexOf(event), 1);
    dataBox.files = []
    if(dataBox.Image)
      dataBox.Image = ''     
      
    event.stopPropagation();
  }

  //商品彈窗 變更目標商店
  onSelectStore(){
    this.getGroupList()
  }


  //處理商品資料
  toProductDetail(data) {
    
    if(this.info.orgType != 3  ) {
      this.mealData = Object.assign(this.mealData, data,data.Main,data.Detail)
    }
    else{
      this.mealData = Object.assign(this.mealData, data)
    }

    //如果供應時間有值,拆解字串
    if (
      this.mealData.SupplyDay != null &&
      this.mealData.SupplyDay != ""
    ) {
      const myArray = this.mealData.SupplyDay.split(",");
      myArray.forEach((day) => {
        if ("1" == day) {
          this.mealData.supplyTimeMonday = true;
        }
        if ("2" == day) {
          this.mealData.supplyTimeTuesday = true;
        }
        if ("3" == day) {
          this.mealData.supplyTimeWednesday = true;
        }
        if ("4" == day) {
          this.mealData.supplyTimeThursday = true;
        }
        if ("5" == day) {
          this.mealData.supplyTimeFriday = true;
        }
        if ("6" == day) {
          this.mealData.supplyTimeSaturday = true;
        }
        if ("7" == day) {
          this.mealData.supplyTimeSunday = true;
        }
      });
      this.showSupplyTime()
    }
    //填充供應時間
    this.mealData.supplyPeriod = [];
    if (this.mealData.FirstSupplyStartTime != null) {
      var tmp = new supplyPeriod();
      tmp.startTime = new Date(this.mealData.FirstSupplyStartTime);
      tmp.endTime = new Date(this.mealData.FirstSupplyEndTime);
      this.mealData.supplyPeriod.push(tmp);

      if (this.mealData.SecondSupplyStartTime != null) {
        var tmp = new supplyPeriod();
        tmp.startTime = new Date(this.mealData.SecondSupplyStartTime);
        tmp.endTime = new Date(this.mealData.SecondSupplyEndTime);
        this.mealData.supplyPeriod.push(tmp);
      }
    }
  }

  
  async toSalesOutletDetail(data) {
    await this.getStoreList();
    
    
    if (this.info.moType != 1){

      const numbersSet = new Set(data.Detail.ProductStoreMapJsonDatas?.[0]?.ORG_Store_ID.split(',') || []);

      const showData = this.info.storeList.map((store, index) => ({
        storeID: store.value,
        storeName: store.content,
        Sort: index + 1,
        IsSell: numbersSet.has(store.value.toString()),
      }));
    
      this.mealData.ProductStoreMapJsonData = showData
        .filter(item => item.IsSell)
        .map(item => item.storeName)
        .join('、');

      this.SalesOutletSetting.showData = showData;
    } else {
      const showData = this.info.storeList.map((store, index) => ({
        storeID: store.value,
        storeName: store.content,
        Sort: index + 1,
        IsSell: false,
      }));

      this.SalesOutletSetting.showData = showData;
    }
  }


  async toStoreSaleCashDetail(data) {
    await this.getStoreList();
    const storeSaleCash = data.Detail.ProductStoreCashMapJsonDatas
    this.mealData.ProductStoreCashMapJsonData = []
    let i = 0
    let showData = this.info.storeList.map((store, index) => ({
      ORG_Store_ID: store.value,
      storeName: store.content,
      Sort: index + 1,
      SaleCash: null,
    }));

    if (this.info.moType != 1){

      if (storeSaleCash){
        storeSaleCash.forEach(x => {
          const orgStoreIdStr = storeSaleCash?.[i]?.ORG_Store_ID.toString();
          const numbersSet = new Set(orgStoreIdStr.split(',') || []);

          let storename = [];

          numbersSet.forEach(y => {
            let obj = showData.find(z => z.ORG_Store_ID == y)
            if (obj){
              obj.SaleCash = x.SaleCash
            }
            let obj2 = this.info.storeList.find(z => z.value == y)
            if (obj2){
              storename.push({storeName: obj2.content})
            }
          })

          this.mealData.ProductStoreCashMapJsonData.push({
            EOSProductNo: this.mealData.EOSProductNo,
            ORG_Company_ID: this.mealData.ORG_Company_ID,
            ORG_Store_ID: orgStoreIdStr,
            SaleCash: storeSaleCash?.[i]?.SaleCash,
            Sorting: 1,
            IsDelete: false,
            storeName: storename.map(obj => obj.storeName).join('、'),
          })

          this.mealData.ProductStoreCashMapJsonData = this.mealData.ProductStoreCashMapJsonData.filter( data => data.SaleCash !== null)
          i++
        });
      }
      
      this.StoreSaleCashSetting.showData = showData;

    } else {
      const showData = this.info.storeList.map((store, index) => ({
        storeID: store.value,
        storeName: store.content,
        Sort: index + 1,
        SaleCash: null,
      }));

      this.StoreSaleCashSetting.showData = showData;
    }
  }


  //附加品項分類  
  @ViewChild('SelectAttMMO_Tmp', { static: false }) SelectAttMMO_Tmp
  SelectAttMMO = {
    info: {
    },
    isShow: false,
    data: null,
    other: {
      attList: [],
    },
    onOpen: () => {
      let my = this.SelectAttMMO
      my.info = {
      }

      my.data = []
      // if (this.mealData.AttachItemGroupJsonDatas){
      //   my.data = _.cloneDeep(this.mealData.AttachItemGroupJsonDatas);
      //   my.data.forEach(x=>{
      //     x.No = x.PRDMenuAttachItemGroupNo 
      //  })
      // }

      my.isShow = true
      //this.SelectAttMMO_Tmp.onOpen(my.info,pdList)
    },
    onSave: (data) => {
      let my = this.SelectAttMMO

      if (!this.mealData.AttachItemGroupJsonDatas)
      this.mealData.AttachItemGroupJsonDatas = []
      let list = []

      data.forEach(p=>{
        if(this.mealData.AttachItemGroupJsonDatas
          .findIndex(x=>x.PRDMenuAttachItemGroupNo==p.No)==-1){
            p.Sorting=0
            list.push(p)
          }
      })
      
      this.mealData.AttachItemGroupJsonDatas =
      this.mealData.AttachItemGroupJsonDatas.concat(list)  
    },
    onClose(v) {
      this.isShow = false
    }
  }


  //附加品項群組 選擇
  @ViewChild("SelectAttGMO_Tmp", { static: false }) SelectAttGMO_Tmp;
  SelectAttGM = {
    info: {
      ORG_Company_ID: null,
      ORG_Store_ID: null,
    },
    isShow: false,
    data: null,
    onOpen: () => {
      let my = this.SelectAttGM;
      if (this.mealData.AttachItemGroupJsonDatas)
        my.data = _.cloneDeep(this.mealData.AttachItemGroupJsonDatas);

      my.info = {
        ORG_Company_ID: this.ORG_Company_ID,
        ORG_Store_ID: this.ORG_Store_ID,
      }
      //this.SelectAttGMO_Tmp.onOpen(my.info, my.data);
      my.isShow = true
    },
    onSave: (data) => {
      let my = this.SelectAttGM;
      this.mealData.AttachItemGroupJsonDatas = data
    },
    onClose(v) {
      this.isShow = false
    }
  };


  //附加品項群組 查看 
  @ViewChild('EditEOSAttachGMO_Tmp', { static: false }) EditEOSAttachGMO_Tmp
  EditEOSAttachGMO = {
    info: {
      ORG_Company_ID: null,
      ORG_Store_ID: null,
      GroupNo: null,
      moType: null,
      orgType:null,
    },
    isShow: false,
    data: {},
    onOpen: (type, data) => {
      let my = this.EditEOSAttachGMO
      my.info = {
        ORG_Company_ID: this.ORG_Company_ID,
        ORG_Store_ID: this.info.ORG_Store_ID,
        GroupNo: data ? data.PRDMenuAttachItemGroupNo ? data.PRDMenuAttachItemGroupNo : data.PRDAttachItemGroupNo  : null, 
        moType: type,
        orgType:this.info.orgType,
      }


      //事件會早於屬性匯入前執行 因此必須改使用參數
      //this.EditEOSAttachMO_Tmp.onOpen(my.info,my.data)
      my.isShow = true
    },
    onSave: (data) => {
      if (data.ORG_Store_ID != this.ORG_Store_ID) {
        alert("群組門市需要與商品門市一致!")
        return
      }

    },
    onClose(v) {
      this.isShow = false
    }
  }


  //-----------------------販售門市設定 >------------------------------
  @ViewChild('SalesOutletSetting_Tmp', { static: false }) SalesOutletSetting_Tmp
  SalesOutletSetting = {
    data: null, //彈窗的項目
    showData:[
      // Idx:null,
      // Size:null,
      // TagNameList:null,
    ], //顯示的資料
    isShow: false,
    //管理
    onOpen: () => {
      const self = this;
      let my = self.SalesOutletSetting

      my.data = []
      my.data = my.showData
      my.isShow = true
      my.init()
    },   
    onSave: (data) => {
      const self = this;
      let my = self.SalesOutletSetting

      self.mealData.ProductStoreMapJsonData = data
      .filter(item => item.IsSell === true) 
      .map(item => item.storeName)
      .join('、');
    
      my.showData = data
      my.init()
    },
    onClose(v) {
      this.isShow = false
    },
    init:()=>{
      let my = this.SalesOutletSetting
      this.mealData.ProductStoreMapJsonDatas=[]

      let test : string
      test = my.showData
      .filter(item => item.IsSell === true) 
      .map(item => item.storeID)
      .join(',');

      this.mealData.ProductStoreMapJsonDatas.push({
        EOSProductNo: this.mealData.EOSProductNo,
        ORG_Company_ID: this.ORG_Company_ID,
        ORG_Store_ID: test,
        IsSell: true,
        Sorting: 1,
        IsDelete: false,
      })
    }
  }


  //-----------------------販售門市金額設定 >------------------------------
  @ViewChild('StoreSaleCashSetting_Tmp', { static: false }) StoreSaleCashSetting_Tmp
  StoreSaleCashSetting = {
    data: null, //彈窗的項目
    showData:[
      // Idx:null,
      // Size:null,
      // TagNameList:null,
    ], //顯示的資料
    isShow: false,
    sourceData: null,
    cash: null,
    //管理
    onOpen: (item) => {
      const self = this;
      let my = self.StoreSaleCashSetting
      my.change()
      my.data = []

      my.cash = item.SaleCash
      my.data = my.showData
      if (my.cash == null){
        alert("請先填寫售價!");
        return null;
      } 
      my.isShow = true
    },   
    onSave: (data) => {
      const self = this;
      let my = self.StoreSaleCashSetting
      my.change()

      my.showData = data.map(e => ({
        ...e,
        SaleCash: e.isChecked 
                  ? my.cash
                  : (e.SaleCash === my.cash ? null : e.SaleCash) 
      }));

      my.init()
    },
    onDel:(item)=>{
      const self = this;
      let my = self.StoreSaleCashSetting
      my.change()

      my.showData = my.showData.map(e => ({
        ...e,
        SaleCash: e.SaleCash === item.SaleCash ? null : e.SaleCash 
      }));
      my.init()
    },
    onClose(v) {
      this.isShow = false
    },
    onAddShow:()=>{  
      const self = this;
      let my = self.StoreSaleCashSetting

      self.mealData.ProductStoreCashMapJsonData.push({
        EOSProductNo: this.mealData.EOSProductNo,
        ORG_Company_ID: this.mealData.ORG_Company_ID,
        ORG_Store_ID: null,
        SaleCash: null,
        Sorting: 1,
        IsDelete: false,
        storeName: '',
      }) 
    },
    change:()=>{
      let my = this.StoreSaleCashSetting
      let i = 0
      let changeData = this.mealData.ProductStoreCashMapJsonData.filter(item => item.ORG_Store_ID !== null);
      
      changeData.forEach(data =>{
        const orgStoreIdStr = data.ORG_Store_ID.toString();
        const numbersSet = new Set(orgStoreIdStr.split(',') || []);

        numbersSet.forEach( data2 => {
          let obj = my.showData.find(x => x.ORG_Store_ID == data2)
          if (obj){
            obj.SaleCash = data.SaleCash
          }
        })
        i++
      })
    },
    init:()=>{
      let my = this.StoreSaleCashSetting

      const groupedBySaleCash = my.showData.reduce((acc, {ORG_Store_ID, storeName, SaleCash }) => {
        // 如果累加器中已存在該SaleCash的條目，則追加storeName，否則新增條目
        if (SaleCash === null) {
          return acc;
        }
        if (acc[SaleCash]) {
          acc[SaleCash].storeName += `、${storeName}`;
          acc[SaleCash].ORG_Store_ID += `,${ORG_Store_ID}`;
        } else {
          acc[SaleCash] = { storeName, ORG_Store_ID: ORG_Store_ID.toString(), SaleCash };
        } 
        acc[SaleCash].EOSProductNo = this.mealData.EOSProductNo
        acc[SaleCash].ORG_Company_ID = this.mealData.ORG_Company_ID
        acc[SaleCash].Sorting = 1
        acc[SaleCash].IsDelete = false
        return acc;
      }, {});
      
      // 將物件轉換為陣列
      this.mealData.ProductStoreCashMapJsonData = Object.values(groupedBySaleCash);
    }
  }


  //附加品項群組 刪除
  DelAttachG(index) {
    this.mealData.AttachItemGroupJsonDatas.splice(index, 1)
  }



  //取得使用中菜單檔 商品細項API
  getProductDetail(callback) {
    let par = {
      EOSProductGroupNo :this.info.EOSProductGroupNo, 
      EOSProductNo :this.info.EOSProductNo,
      ORG_Store_ID : this.info.ORG_Store_ID 
    }
    this.http
      .post<any>(
        "api/UsingMenu/GetProductDetail",par)
      .subscribe({
        next: (data) => {
          if (data.LIST.length > 0) {
            let obj = data.LIST[0]
            obj.EOSProductGroupNo = obj.PRDProductGroupNo
            this.toProductDetail(obj)
          }
        },
        error: (error) => {
          console.error("取得商品細項API error!", error);
        },
      });
  }

// 修改 getStoreList() 方法使其返回一個 Promise
getStoreList(): Promise<any> {
  return this.http.post<any>('api/ORGStore/StoreList', {
    USR_AccountInfo_ID: this.USR_AccountInfo_ID,      
    ORG_Company_ID: this.ORG_Company_ID.toString(),
    ORG_Store_ID: this.ORG_Store_ID.toString(),
  }).toPromise().then(data => {
    this.info.storeList = [];

    //門市共用下拉選單
    let Item: any = {};
    Item.value = 0;
    Item.content = '總部';
    this.info.storeList.push(Item);

    if (this.ORG_Store_ID) {
      //門市共用下拉選單
      let Item: any = {};
      Item.value = this.ORG_Store_ID;
      Item.content = data.LIST.find(x => x.ORG_Store_ID == this.ORG_Store_ID).StoreName;
      this.info.storeList.push(Item);
    } else {
      data.LIST.forEach(element => {
        //門市共用下拉選單
        var selectItem = new selectData();
        selectItem.value = element.ORG_Store_ID;
        selectItem.content = element.StoreName;
        this.info.storeList.push(selectItem);
      });
    }

    // 預設點第一個
    if (this.info.storeList.length > 0) {
      this.mealData.CopyStoreID = this.info.storeList[0].value;
    }

    return data; // 返回數據以供進一步處理
  }).catch(error => {
    console.error('There was an error!', error);
    throw error; // 重新拋出錯誤以便調用者處理
  });
}



  //取得群組
  getGroupList(){

    if(this.info.orgType == 1){
      let par = {
        ORG_Company_ID: this.ORG_Company_ID,
        CreateStore: this.mealData.CopyStoreID == null ? 0 : this.mealData.CopyStoreID,
        IsDelete: false,
      }    
      
      this.http.post<any>('api/ProductSetting/GetProductGroup', par).subscribe({
        next: data => {
          this.info.groupList = []
          data.LIST.forEach(element => {
            let item = new selectData();
            item.value = element.EOSProductGroupNo;
            item.content = element.GroupName;
            this.info.groupList.push(item);
          });

          if(this.info.groupList.length>0)
            this.mealData.EOSProductGroupNo = this.info.groupList[0].value.toString() 

          this.info.isChange_Group = !this.info.isChange_Group
        },
        error: error => {
          console.error('There was an error!', error);
  
        }
      });

    }

  }

}

class ModifyPRDProductReq {
  //商品
  EOSProductGroupNo: string; //
  PRDMenuProductGroupNo: string; //
  EOSProductNo: string; //  
  Main: any;
  Detail: any;
  USR_EmployeeInfo_ID: number; //
  USR_AccountInfo_ID: string; //
  ORG_Company_ID: number; //

  //---------------------------------main----------------------  

  ProductName: string; //
  ProductContant: string; //
  Image: string; // 
  TaxRate: number = 5; //
  TaxType: number = 2; //
  Cash: number; //

  //---------------------------------detail----------------------  
  SaleCash: number; //
  Sorting: number; //
  //2024.2.19 新增商品點餐方式(外帶/外送/內用/自取)預設開啟
  IsOpenTakeout: boolean = true;
  IsOpenDelivery: boolean = true;
  IsOpenDining: boolean = true;
  IsOpenReserveDining: boolean = false;
  IsOpenSelfPickup: boolean = true;
  SupplyQTY: number; //
  UplimitQTY: number; //
  SupplyDay: string; //供應日 用,區分，1:週一 2:週二 3:週三 4:週四 5:週五 6:週六 7:週日
  FirstSupplyStartTime: string; //
  FirstSupplyEndTime: string; //
  SecondSupplyStartTime: string; //
  SecondSupplyEndTime: string; // 
  AttachItemGroupJsonDatas: AttachItemGroupJsonDataDTO[];
  AttachItemGroupJsonData: string; //已存在的附加品項清單  用,分隔
  ProductStoreMapJsonDatas: ProductStoreMapJsonDataDTO[]; // 販售門市對應
  ProductStoreMapJsonData: string; // 已存在的販售門市
  ProductStoreCashMapJsonDatas: ProductStoreCashMapJsonDataDTO[]; // 販售門市金額對應
  ProductStoreCashMapJsonData: StoreCashData[]; //  已存在的販售門市金額對應

  //---------------------------------顯示用----------------------
  supplyPeriod?: Array<supplyPeriod>; //供應時段 
  supplyDayStr: string;
  supplyTimeMonday?: boolean;
  supplyTimeTuesday?: boolean;
  supplyTimeWednesday?: boolean;
  supplyTimeThursday?: boolean;
  supplyTimeFriday?: boolean;
  supplyTimeSaturday?: boolean;
  supplyTimeSunday?: boolean;
  files: ImageFile[] = [];

  //---------------------------------old----------------------
  ORG_Store_ID?: number; //
  CopyStoreID?: number; //複製用，目標商店ID

}

class supplyPeriod {
  startTime: Date;
  endTime: Date;
}

class AttachItemGroupJsonDataDTO {
  PRDMenuAttachItemGroupNo: string; //附加品項群組編號
  GroupName: string
  Content: string
  AttachItemKindName: string
  IsRequiredName: string
  Sorting:number
}


class ImageFile extends File {
  path: string;
}

class selectData {
  value: number; //
  content: string; //
}

class ProductStoreMapJsonDataDTO {
  EOSProductNo: string;
  ORG_Company_ID: number
  ORG_Store_ID: string
  IsSell: boolean
  Sorting: number
  IsDelete: boolean
}

class ProductStoreCashMapJsonDataDTO {
  EOSProductNo: string;
  ORG_Company_ID: number
  ORG_Store_ID: string
  SaleCash: number
  Sorting: number
  IsDelete: boolean
}

class StoreCashData {
  EOSProductNo: string;
  ORG_Company_ID: number
  ORG_Store_ID: string
  SaleCash: number
  Sorting: number
  IsDelete: boolean
  storeName: string;
}